import { Check, Circle, Loader2 } from "lucide-react";
import type { SectionComponentProps } from "./registry";

type Step = {
  step: number;
  label: string;
  status: "done" | "active" | "pending";
  description?: string;
};

export function ProgressTrackerSection({ data }: SectionComponentProps) {
  const steps = data as Step[];
  if (!steps?.length) return null;

  return (
    <div className="space-y-0">
      {steps.map((step, i) => {
        const isDone = step.status === "done";
        const isActive = step.status === "active";
        return (
          <div key={i} className="flex gap-3 relative">
            {/* Connector line */}
            {i < steps.length - 1 && (
              <div
                className={`absolute left-[13px] top-8 bottom-0 w-px ${isDone ? "bg-emerald-500/40" : "bg-border"}`}
              />
            )}
            {/* Step icon */}
            <div
              className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 z-10 ${
                isDone
                  ? "bg-emerald-500 text-white"
                  : isActive
                    ? "bg-violet-500/20 text-violet-400 border-2 border-violet-500"
                    : "bg-muted text-muted-foreground border-2 border-border"
              }`}
            >
              {isDone ? (
                <Check className="w-3.5 h-3.5" />
              ) : isActive ? (
                <Loader2 className="w-3.5 h-3.5 animate-spin" />
              ) : (
                <Circle className="w-3 h-3" />
              )}
            </div>
            {/* Content */}
            <div className="flex-1 pb-5">
              <div className={`text-sm font-medium ${isDone ? "text-emerald-500" : isActive ? "text-foreground" : "text-muted-foreground"}`}>
                {step.label}
              </div>
              {step.description && (
                <p className="text-xs text-muted-foreground mt-0.5">{step.description}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
